export default {
    addPack(state, pack) {
        state.items.push(pack)
    },
    setItems(state, items) {
        state.items = items
    }
}